
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComMessageActiveGoogle as ObiComMessageActiveGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-com-message-active-google.js';
 
 
 

 
 export const ObiComMessageActiveGoogle = createComponent({
   react: React,
   tagName: 'obi-com-message-active-google',
   elementClass: ObiComMessageActiveGoogleElement,
   events: {
     
   }
  });
 
 